<template>
  <GChart
    class="headline mx-4"
    type="PieChart"
    style="width: 110%; height: 400px;"
    :data="chartArray"
    :options="chartOptions"
  />
</template>

<script>
export default {
  props: {
    gender: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      chartOptions: {
        title: "Users Participation Rotio",
        legend: "none",
        is3D: true,
        pieSliceText: "label",
        slices: {
          1: { offset: 0.2 }
          // 12: { offset: 0.3 },
          // 19: { offset: 0.5 }
        }
      }
    };
  },
  methods: {
    percentileIt(lst) {
      var total = lst[0][1] + lst[1][1];
      var newlst = [["Participants", "Gender"]];
      lst.forEach(ele => {
        newlst.push([ele[0], (ele[1] / total) * 100]);
      });
      return newlst;
    }
  },
  computed: {
    chartArray() {
      var x = [];
      if (this.gender.length > 0) {
        this.gender.forEach(gen => {
          x.push([gen.Gender, gen.total]);
        });
      }
      return this.percentileIt(x);
    }
  }
};
</script>